import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const SecuritySolutions = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Security Solutions</h1>
            <p className="service-description">
              Comprehensive cybersecurity solutions to protect your business 
              from evolving digital threats and ensure data integrity.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Security Services</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔥</div>
                    <h3>Firewall Management</h3>
                  </div>
                  <p>Advanced firewall configuration and management to protect against unauthorized access.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Firewall Management</div>
                    <ul className="popover-list">
                      <li>Policy design, rule cleanup and change control</li>
                      <li>NAT, VPN, HA pairs and failover</li>
                      <li>App‑ID/URL filtering and threat profiles</li>
                      <li>Logging, syslog/SIEM forwarding</li>
                      <li>Compliance templates and audits</li>
                      <li>Firmware lifecycle and backups</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔐</div>
                    <h3>Endpoint Protection</h3>
                  </div>
                  <p>Comprehensive endpoint security solutions including antivirus, anti-malware, and intrusion detection.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Endpoint Protection</div>
                    <ul className="popover-list">
                      <li>EDR rollout and policy tuning</li>
                      <li>Next‑gen AV, device control and DLP</li>
                      <li>Disk encryption and key escrow</li>
                      <li>Patch baselines and automated updates</li>
                      <li>Threat hunting and remediation playbooks</li>
                      <li>Reporting and compliance posture</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔍</div>
                    <h3>Vulnerability Assessment</h3>
                  </div>
                  <p>Regular security audits and vulnerability assessments to identify and address potential threats.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Vulnerability Assessment</div>
                    <ul className="popover-list">
                      <li>External/internal scans and credentialed checks</li>
                      <li>Risk scoring, exploitability and prioritization</li>
                      <li>Remediation guidance and tracking</li>
                      <li>Configuration baseline and hardening reviews</li>
                      <li>Compliance reporting (CIS/NIST/ISO)</li>
                      <li>Retesting and verification</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">📊</div>
                    <h3>Security Monitoring</h3>
                  </div>
                  <p>8 X 6 security monitoring and incident response to detect and mitigate threats in real-time.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Security Monitoring</div>
                    <ul className="popover-list">
                      <li>SIEM dashboards, alerts and correlation</li>
                      <li>Log onboarding and retention policies</li>
                      <li>Use‑case development and tuning</li>
                      <li>Incident triage, IR playbooks and RCA</li>
                      <li>Threat intel integrations</li>
                      <li>KPIs and executive reporting</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Security Benefits</h2>
                <ul className="benefits-list">
                  <li>✓ Multi-layered security approach</li>
                  <li>✓ Compliance with industry standards</li>
                  <li>✓ Real-time threat detection</li>
                  <li>✓ Regular security updates and patches</li>
                  <li>✓ Employee security training</li>
                  <li>✓ Incident response planning</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Monitoring:</span>
                  <span className="highlight-value">8 X 6</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Response:</span>
                  <span className="highlight-value">Real-time</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Compliance:</span>
                  <span className="highlight-value">Multi-standard</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Certification:</span>
                  <span className="highlight-value">CISSP</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default SecuritySolutions;
